var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Mssg = dynamicRequire('Mssg.jsx');

class UnitSwitcher extends React.Component {

    render() {
        var mmClasses = 'rs-btn lr-casefactory-choices-sliders-dimensions-unit unit' + (this.props.isCmMode ? '' : ' lr-casefactory-choices-sliders-dimensions-unit-active active')
        var cmClasses = 'rs-btn lr-casefactory-choices-sliders-dimensions-unit unit' + (this.props.isCmMode ? ' lr-casefactory-choices-sliders-dimensions-unit-active active' : '')

        return <div className="lr-casefactory-choices-sliders-dimensions-unit-selector unit-selector">
            <span className={cmClasses} onClick={(e) => {this.context.emitter.emit('unitMode', 'cm')}}><Mssg __key="nc_casefactory.centimeter" /></span>
            <span className={mmClasses} onClick={(e) => {this.context.emitter.emit('unitMode', 'mm')}}>mm</span>
        </div>
    }
}

UnitSwitcher.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = UnitSwitcher;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/UnitSwitcher.jsx